(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgtp-card-product-hidden"]) return;
  try {
    
// add local storage for recently viewed products
class RecentlyViewedProducts {
  constructor() {
    this.storageKey = 'recently_viewed_products';
    this.maxItems = 8;
  }
  addProduct(productId) {
    let products = this.getProducts();
    // Remove if already exists
    products = products.filter(id => id !== productId);
    // Add to the front
    products.unshift(productId);
    // Limit to maxItems
    if (products.length > this.maxItems) {
      products = products.slice(0, this.maxItems);
    }
    localStorage.setItem(this.storageKey, JSON.stringify(products));
  }
  getProducts() {
    const products = localStorage.getItem(this.storageKey);
    return products ? JSON.parse(products) : [];
  }
}
document.addEventListener('DOMContentLoaded', function() {
  const productTemplate = document.querySelector('template#tgtp-card-product-hidden-template');
  if (productTemplate) {
    const productId = productTemplate.getAttribute('data-product-id');
    const recentlyViewed = new RecentlyViewedProducts();
    recentlyViewed.addProduct(productId);
  }
});



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgtp-mega-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('#MegaHeaderLanguageForm[data-localization-form]');

    if (!forms.length) return;

    forms.forEach(function (form) {
      var toggle = form.querySelector('[data-localization-toggle]');
      var panel = form.querySelector('[data-localization-panel]');
      var currentLabel = form.querySelector('[data-localization-current]');
      var hiddenInput = form.querySelector('input[name="locale_code"]');
      var options = form.querySelectorAll('[data-localization-option]');

      if (!toggle || !panel || !hiddenInput) return;

      function openPanel() {
        panel.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }

      function closePanel() {
        panel.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
      }

      function togglePanel() {
        var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
        if (isExpanded) {
          closePanel();
        } else {
          openPanel();
        }
      }

      // トグルボタンで開閉
      toggle.addEventListener('click', function (event) {
        event.preventDefault();
        togglePanel();
      });

      // オプション選択 → hiddenInput 更新 → submit
      options.forEach(function (option) {
        option.addEventListener('click', function (event) {
          event.preventDefault();

          var newValue = option.getAttribute('data-value');
          var newLabel =
            option.getAttribute('data-label') ||
            option.textContent.replace(/\s+/g, ' ').trim();

          if (!newValue) return;

          // 同じ言語ならフォーム送信せず閉じるだけ
          if (newValue === hiddenInput.value) {
            closePanel();
            return;
          }

          hiddenInput.value = newValue;

          if (currentLabel) {
            currentLabel.textContent = newLabel;
          }

          form.submit();
        });
      });

      // 外側クリックで閉じる
      document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) {
          closePanel();
        }
      });

      // ESC キーで閉じる
      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
          closePanel();
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgtp-popup-cart-quest"] && !Shopify.designMode) return;
  try {
    
// when tgtp-popup-cart-quest-openbutton clicked, check closest tgtp-popup-cart-quest, and get tgtp-popup-cart-quest-window is open
  document.querySelectorAll('.tgtp-popup-cart-quest-openbutton').forEach(button => {
    button.addEventListener('click', function() {
      const popupCartQuest = button.closest('.tgtp-popup-cart-quest');
      const questWindow = popupCartQuest.querySelector('.tgtp-popup-cart-quest-window');
      const isOpen = questWindow.getAttribute('data-tgtp-quest-window-open') === 'true';
      if (isOpen) {
        questWindow.setAttribute('data-tgtp-quest-window-open', 'false');
      } else {
        questWindow.setAttribute('data-tgtp-quest-window-open', 'true');
      }
    });
  });

  // when tgtp-popup-cart-quest__closebutton clicked, close tgtp-popup-cart-quest-window
  document.querySelectorAll('.tgtp-popup-cart-quest__closebutton').forEach
  (button => {
    button.addEventListener('click', function() {
      const popupCartQuest = button.closest('.tgtp-popup-cart-quest');
      const questWindow = popupCartQuest.querySelector('.tgtp-popup-cart-quest-window');
      questWindow.setAttribute('data-tgtp-quest-window-open', 'false');
      questWindow.setAttribute('data-tgtp-quest-selected-contents-step', '1');
    });
  });

  // when tgtp-popup-cart-quest-contents__back-cart-button clicked, close tgtp-popup-cart-quest-window
  document.querySelectorAll('.tgtp-popup-cart-quest-contents__back-cart-button').forEach
  (button => {
    button.addEventListener('click', function() {
      const popupCartQuest = button.closest('.tgtp-popup-cart-quest');
      const questWindow = popupCartQuest.querySelector('.tgtp-popup-cart-quest-window');
      questWindow.setAttribute('data-tgtp-quest-window-open', 'false');
      questWindow.setAttribute('data-tgtp-quest-selected-contents-step', '1');
    });
  });


  // when tgtp-popup-cart-quest-contents__back-qa-button clicked, step to 1
  document.querySelectorAll('.tgtp-popup-cart-quest-contents__back-qa-button').forEach
  (button => {
    button.addEventListener('click', function() {
      const popupCartQuest = button.closest('.tgtp-popup-cart-quest');
      const questWindow = popupCartQuest.querySelector('.tgtp-popup-cart-quest-window');
      questWindow.setAttribute('data-tgtp-quest-selected-contents-step', '1');
    });
  }); 


  document.querySelectorAll('.tgtp-popup-cart-quest-openbutton').forEach(button => {
    const numberElement = button.querySelector('.tgtp-popup-cart-quest-openbutton__number');
    const popupCartQuest = button.closest('.tgtp-popup-cart-quest');
    const enableButtons = popupCartQuest.querySelectorAll('.tgtp-popup-cart-quest-selectbox__button--enable');
    const count = enableButtons.length;
    if (count > 0) {
      numberElement.style.display = 'flex';
      numberElement.innerText = count;
      button.style.display = 'block';
    } else {
      numberElement.style.display = 'none';
      numberElement.innerText = ''; 
      button.style.display = 'none';
    }
  });


    // スクロール一番下に来た時を検知して、tgtp-popup-sale-openbuttonに対し、クラス付与r
  let elemTgtpPopupCartQuestButtons = document.querySelectorAll('.tgtp-popup-cart-quest-openbutton');
  if (elemTgtpPopupCartQuestButtons.length != 0) {
    console.log(elemTgtpPopupCartQuestButtons);
    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const documentHeight = document.documentElement.scrollHeight;
      elemTgtpPopupCartQuestButtons.forEach(button => {
        if (scrollTop + windowHeight >= documentHeight - 10) {
          button.classList.add('tgtp-popup-cart-quest-openbutton--hidden');
        } else {
          button.classList.remove('tgtp-popup-cart-quest-openbutton--hidden');
        }
      });
    });
  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tgtp-popup-sale"] && !Shopify.designMode) return;
  try {
    
// when tgtp-popup-sale-openbutton clicked, check closest tgtp-popup-sale, and get tgtp-popup-sale-window is open
  document.querySelectorAll('.tgtp-popup-sale-openbutton').forEach(button => {
    button.addEventListener('click', function() {
      const popupCartSale = button.closest('.tgtp-popup-sale');
      const saleWindow = popupCartSale.querySelector('.tgtp-popup-sale-window');
      const isOpen = saleWindow.getAttribute('data-tgtp-popup-sale-window-open') === 'true';
      if (isOpen) {
        saleWindow.setAttribute('data-tgtp-popup-sale-window-open', 'false');
        // ここに後ろのbodyのスクロールを元に戻す処理を追加
        document.body.style.overflow = '';
        document.body.style.height = '';
        document.body.style.maxHeight = '';
      } else {
        saleWindow.setAttribute('data-tgtp-popup-sale-window-open', 'true');
        // ここに後ろのbodyのスクロールが動かないようにbodyの高さを100%にしてoverflowをhiddenにする処理を追加
        document.body.style.overflow = 'hidden';
        // document.body.style.height = '100svh';
        // document.body.style.maxHeight = '100vh';
      }
    });
  });

  // when tgtp-popup-sale__closebutton clicked, close tgtp-popup-sale-window
  document.querySelectorAll('.tgtp-popup-sale__closebutton').forEach
  (button => {
    button.addEventListener('click', function() {
      const popupCartSale = button.closest('.tgtp-popup-sale');
      const saleWindow = popupCartSale.querySelector('.tgtp-popup-sale-window');
      saleWindow.setAttribute('data-tgtp-popup-sale-window-open', 'false');
      // ここに後ろのbodyのスクロールを元に戻す処理を追加
      document.body.style.overflow = '';
      // document.body.style.height = '';
      // document.body.style.maxHeight = '';
    });
  });

  // スクロール一番下に来た時を検知して、tgtp-popup-sale-openbuttonに対し、クラス付与r
  let elemTgtpPopupSaleOpenButtons = document.querySelectorAll('.tgtp-popup-sale-openbutton');
  if (elemTgtpPopupSaleOpenButtons.length != 0) {
    window.addEventListener('scroll', function() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const documentHeight = document.documentElement.scrollHeight;
      elemTgtpPopupSaleOpenButtons.forEach(button => {
        if (scrollTop + windowHeight >= documentHeight - 10) {
          button.classList.add('tgtp-popup-sale-openbutton--hidden');
        } else {
          button.classList.remove('tgtp-popup-sale-openbutton--hidden');
        }
      });
    });
  }

  

  } catch(e) { console.error(e); }
})();
})();
